export default __webpack_public_path__ + "static/media/bullet.a4e65989.svg";